export type GuidedChipEventDetail = {
  /**
   * Translated name of the chip the user clicked
   */
  label:string,
  /**
   * original (internal) name of the chip the user clicked
   */
  baseName: string,
  sourceType: string,

  chipType?: ChipType,
  isPromoted?: boolean,
  country?: string,
  language?: string
};

export enum ChipType { //eslint-disable-line @stencil-community/ban-exported-const-enums
  None,
  GuidedV2Sections,
  GuidedV2Suggestions
}

export type HistoryEventDetail = {
  term: string
};
